// extracted by mini-css-extract-plugin
export default {"form":"ArticleCommentDialog_form__Yc8r5"};